<template>
  <div class="singlepic">
    <template v-if="orientation == 'left'">
        <div class="imagebox">
            <img class="boxshadoweffect" :src='img'>
        </div>
        <div class="textbox left"><slot/></div>
    </template>
    <template v-else>
        <div class="textbox "><slot/></div>
        <div class="imagebox">
            <img class="boxshadoweffect" :src='img'>
        </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['img', 'orientation']
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

img.boxshadoweffect {
  box-shadow: 0 2pt 10pt rgba(0, 0, 0, 0.7), 0 0 10pt rgba(0, 0, 0, 0.7) inset;
  width: inherit;
}

@smartphones: ~"only screen and (max-width: 540px)";

.singlepic {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  padding: 20pt;
  flex-wrap: wrap;
  font-family: @serif-font;
  font-size: 13pt;

  @media @smartphones {
    flex-direction: column
  }

}

.singlepic > * {
  flex: 1 0 0;
}

.singlepic .textbox {
  margin: 0 10pt;
  padding: 10pt;
  border-right: solid 1px lightblue;
}

.singlepic .imagebox {
  padding: 10pt;
  width: 100%;
  text-align: center;
}

.singlepic .textbox.left {
  border-right: solid 0px;
  border-left: solid 1px lightblue;
}



</style>


// WEBPACK FOOTER //
// src/components/SinglePictureSection.vue